
import { axios } from '@/utils/request'
import { sysInfo } from '@/config'

export function insertProject (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/project',
    method: 'POST',
    data: parameter
  })
}
export function updateProject (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/project',
    method: 'POST',
    data: parameter
  })
}
export function deleteProject (ids) {
  return axios({
    url: sysInfo.apiRemote + '/project?ids=' + ids,
    method: 'DELETE'
  })
}
export function getProjectList (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/projects',
    method: 'GET',
    params: parameter
  })
}
// export function getProjectInfo (parameter) {
//   return axios({
//     url: sysInfo.apiRemote + '/project',
//     method: 'GET',
//     params: parameter
//   })
// }
